module.exports = __webpack_public_path__ + "assets/img/alerts.704f4425.svg";